import React from "react";
import propTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Route, Switch, Link } from "react-router-dom";
import Modal from "react-modal";
import Swal from "sweetalert2";
import moment from "moment";
import Menu from "./Menu";
import { changeAppLanguage, getObjectDescription } from "./actions";
import lang from "../lang";
import Calendar from "../routes/Calendar";
import GuestList from "../routes/Guest";
import AMA from "../routes/RoomOverview/components/RoomOverview";
import { forceToMonFri } from "../components/DateFunction";
import UserList from "../routes/UserManagement";
import ProfileList from "../routes/UserManagement/Profiles";
import ProfileForm from "../routes/UserManagement/Profiles/ProfileForm";
import { getUserDetail } from "../routes/Login/actions";
import FilterWithAuth from "../components/FilterWithAuth";
import ColumnConfig from "../routes/Guest/ColumnViewing";
import Me from "../routes/UserManagement/Me";
import ConfirmResetPassword from "../routes/Login/ConfirmResetPassword";
import GuestDetail from "../routes/Guest/Detail";
import Notification from "../routes/UserManagement/Notification";
import { createFetch } from "../utils";
const { URL_PREFIX, SF_URL } = window;

class AfterLoginContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      isCollapsed: false,
      modalShown: false,
      meShown: false,
      notifShown: false,
      menuClicked: "app",
    };
    this.getMenuList = this.getMenuList.bind(this);
    this.getGuestList = this.getGuestList.bind(this);
  }

  async componentWillMount() {
    document.body.style = "background-image: none";
    await this.props.getUserDetail(this.props.user.accessToken);
    await this.props.getObjectDescription();
    // await this.getGuestList();
  }

  async getGuestList(forceRefresh = true) {
    const url = new URL(window.location.href);
    const viewId =
      url.searchParams.get("viewId") ||
      this.props.user.info.defaultView ||
      null;
    const { user } = this.props;
    const date = moment(new Date()).format("YYYY-MM-DD");

    try {
      let path = `guest/query?date=${date}&forceRefresh=${forceRefresh.toString()}`;
      if (viewId) {
        path += `&viewId=${viewId}`;
      }
      await createFetch({
        path,
        accessToken: user.accessToken,
        method: "GET",
      });
    } catch (error) {
      Swal.fire({
        title: "Failed to request",
        text: error.message,
        icon: "error",
      });
    }
  }

  getMenuList() {
    const { menuClicked } = this.state;
    const menu = {
      app: [
        {
          linkTo: `${URL_PREFIX}/app/calendar`,
          name: "Calendar",
          icon: require("../static/img/icons/png/calendar.png"),
          profile: "menu:Apps:calendar",
        },
        {
          linkTo: `${URL_PREFIX}/app/ama`,
          name: "AMA",
          icon: require("../static/img/icons/png/admin-laptop.png"),
          profile: "menu:Apps:AMA",
        },
        {
          linkTo: `${URL_PREFIX}/app/guest-list/${moment(
            forceToMonFri(new Date())
          ).format("YYYY-MM-DD")}`,
          name: "Guest List",
          icon: require("../static/img/icons/png/guest-list.png"),
          profile: "menu:Apps:guestList",
        },
      ],
      users: [
        {
          linkTo: `${URL_PREFIX}/app/users`,
          name: "Users",
          icon: "fa-users",
          profile: "menu:userManagement:users",
        },
        {
          linkTo: `${URL_PREFIX}/app/profile`,
          name: "Profile Setting",
          icon: "fa-user",
          profile: "menu:userManagement:profiles",
        },
      ],
    };
    if (menu[menuClicked]) {
      return (
        <div className="action-list">
          {menu[menuClicked].map((o) => (
            <FilterWithAuth authRequired={[o.profile]} key={o.name}>
              <Link
                to={o.linkTo}
                onClick={() => this.setState({ modalShown: false })}
                key={`menu${o.name}`}
              >
                <p>{o.name}</p>
                {o.icon.toString().substr(0, 2) === "fa" ? (
                  <i className={`fa ${o.icon} fa-5x`} />
                ) : (
                  <img src={o.icon} alt={o.name} />
                )}
              </Link>
            </FilterWithAuth>
          ))}
        </div>
      );
    }
    return null;
  }

  render() {
    const { user } = this.props;
    const { isCollapsed, modalShown, meShown, notifShown } = this.state;
    lang.setLanguage(user.language);
    if (user.accessToken === null) {
      return <Redirect to={URL_PREFIX} />;
    }
    return (
      <div className="wrapper">
        <Menu
          isCollapsed={isCollapsed}
          toggleCollapse={(val) => this.setState({ isCollapsed: val })}
          onMenuClicked={(val) =>
            this.setState({ menuClicked: val, modalShown: true })
          }
          changeState={(key, value) => this.setState({ [key]: value })}
          meShown={meShown}
          notifShown={notifShown}
        />
        <div className="content">
          <div className="header">
            <div className="col-sm-2">
              <Link to={URL_PREFIX}>
                <img
                  src={require("../static/img/logo-gems.png")}
                  alt="logo-gems"
                />
              </Link>
            </div>
            <div className="col-sm-2">
              <a href={SF_URL} target="_blank" rel="noopener noreferrer">
                {lang.loginToSalesforce}
              </a>
            </div>
            <div className="col-sm-2">
              <a
                href="https://wakatobiresort.vendhq.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                {lang.loginToVend}
              </a>
            </div>
            {/**
                        // disable language selection
                        <div className="text-right" style={{ alignSelf: 'center', flex: 3 }}>
                            <div className="btn-group" role="group" aria-label="Basic example">
                                <button
                                    type="button"
                                    className={`btn btn-${user.language === 'en' ? 'primary' : 'default'}`}
                                    onClick={() => this.props.changeAppLanguage('en')}
                                >
                                    English
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-${user.language === 'id' ? 'primary' : 'default'}`}
                                    onClick={() => this.props.changeAppLanguage('id')}
                                >
                                    Bahasa
                                </button>
                            </div>
                        </div>
                        */}
          </div>
          <div className="clearfix" />
          <div className="col-lg-12">
            <TransitionGroup>
              <CSSTransition
                key={this.props.location.key}
                classNames="fade"
                timeout={0}
              >
                <Switch location={this.props.location}>
                  <Route
                    path={`${URL_PREFIX}/app`}
                    component={Calendar}
                    exact
                  />
                  <Route
                    path={`${URL_PREFIX}/app/calendar`}
                    component={Calendar}
                  />
                  <Route path={`${URL_PREFIX}/app/ama`} component={AMA} />
                  <Route
                    path={`${URL_PREFIX}/app/guest-list/:date`}
                    component={GuestList}
                  />
                  <Route
                    path={`${URL_PREFIX}/app/users`}
                    component={UserList}
                  />
                  <Route
                    path={`${URL_PREFIX}/app/profile`}
                    component={ProfileList}
                    exact
                  />
                  <Route
                    path={`${URL_PREFIX}/app/profile/:id`}
                    component={ProfileForm}
                  />
                  <Route
                    path={`${URL_PREFIX}/app/column-config/:id`}
                    component={ColumnConfig}
                  />
                  <Route
                    path={`${URL_PREFIX}/app/reset-password`}
                    component={ConfirmResetPassword}
                  />
                  <Route
                    path={`${URL_PREFIX}/app/guest/:id`}
                    component={GuestDetail}
                  />
                </Switch>
              </CSSTransition>
            </TransitionGroup>
          </div>
        </div>
        <Modal
          isOpen={modalShown}
          onRequestClose={() => this.setState({ modalShown: false })}
          className="action"
          ariaHideApp={false}
        >
          {this.getMenuList()}
        </Modal>
        <Me
          visible={meShown}
          toggleModal={() => this.setState({ meShown: !meShown })}
          history={this.props.history}
        />
        <Notification
          toggleModal={() => this.setState({ notifShown: !notifShown })}
          history={this.props.history}
          visible={notifShown}
        />
      </div>
    );
  }
}

AfterLoginContainer.propTypes = {
  user: propTypes.object.isRequired,
  location: propTypes.object.isRequired,
  changeAppLanguage: propTypes.func.isRequired,
  getUserDetail: propTypes.func.isRequired,
  getObjectDescription: propTypes.func.isRequired,
  history: propTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeAppLanguage,
      getUserDetail,
      getObjectDescription,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AfterLoginContainer);
